import { z } from 'zod';
const uuidSchema = z
    .string()
    .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
/**
 * What put an item in the inbox (productspec §9, M4). `mention` and `reply` are
 * written when a comment names you or answers a thread you follow; `assigned`
 * and `access_requested` arrive from the pages and the share dialog.
 */
export const inboxKindSchema = z.enum(['mention', 'reply', 'assigned', 'access_requested']);
export const inboxFilterSchema = z.object({
    /** `all` keeps unread too, `archived` shows what was filed away. */
    view: z.enum(['all', 'unread', 'archived']).default('all'),
    /** Only mentions and replies, hiding the rest. */
    mentionsOnly: z.coerce.boolean().default(false),
    workspaceId: z.string().trim().max(36).optional(),
});
export const inboxItemIdSchema = uuidSchema;
export const archiveInboxSchema = z.object({ archived: z.boolean() });
//# sourceMappingURL=inbox.js.map